export default "__VITE_ASSET__UTWL_RRx__"